export function parseLocalizedNumberInput(value: unknown): number | null {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;

    const normalized = String(value).trim();
    if (!normalized) return null;

    const decimalSeparator = getDecimalSeparator(normalized);
    const sanitized =
        decimalSeparator === ','
            ? normalized.replace(/\./g, '').replace(',', '.')
            : normalized.replace(/,/g, '');
    const parsed = Number(sanitized);

    return Number.isFinite(parsed) ? parsed : null;
}

function getDecimalSeparator(value: string): ',' | '.' {
    const lastComma = value.lastIndexOf(',');
    const lastDot = value.lastIndexOf('.');

    return lastComma > lastDot ? ',' : '.';
}
